var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRsaLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 151.844,
    height: 151.844,
    rx: 75.922,
    fill: "#EFF8F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3883_5932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.214 108.11C73.7687 108.11 71.5626 106.861 70.2868 104.788L55.9869 81.4507C53.3821 77.5435 52 72.9186 52 68.1609C52 54.8445 62.8445 44 76.1609 44C89.4772 44 100.322 54.8445 100.322 68.1609C100.322 72.8654 98.9662 77.4371 96.3879 81.3709L87.8027 95.5378C87.4306 96.1758 86.6066 96.3618 85.9687 95.9897C85.3308 95.6176 85.1448 94.7936 85.5169 94.1557L94.1287 79.9622C96.4411 76.4271 97.6372 72.3604 97.6372 68.1874C97.6372 56.3064 88.0154 46.658 76.1609 46.658C64.3064 46.658 54.658 56.3064 54.658 68.1609C54.658 72.4136 55.8806 76.5069 58.2196 80.0154L72.546 103.405C73.3434 104.681 74.699 105.452 76.214 105.452C77.7291 105.452 79.0846 104.681 79.8554 103.379L82.1147 99.6577C82.4868 99.0198 83.3108 98.8337 83.9487 99.2058C84.5866 99.5779 84.7726 100.402 84.4005 101.04L82.1413 104.761C80.892 106.861 78.6859 108.11 76.214 108.11C76.2406 108.11 76.214 108.11 76.214 108.11Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1602 79.1642C82.2375 79.1642 87.1642 74.2375 87.1642 68.1602C87.1642 62.0829 82.2375 57.1562 76.1602 57.1562C70.0829 57.1562 65.1562 62.0829 65.1562 68.1602C65.1562 74.2375 70.0829 79.1642 76.1602 79.1642Z",
    fill: "#05D484"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3883_5932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.2951,
    height: 64.11,
    fill: "white",
    transform: "translate(52 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsaLocation);
export default __webpack_public_path__ + "static/media/RSALocation.78cfa824.svg";
export { ForwardRef as ReactComponent };